import React from "react";
import { PageTitleSection } from "./PageTitleSection";

export default function PageTitleSectionResponsive() {
  return <PageTitleSection />;
}
